import type { SVGProps } from 'react';

import { unitMapping, type Unit } from '#src/lib/style.ts';
import type { Color } from '#src/style/types.ts';

type Props = { size?: Unit; color?: Color };

export const Cash = ({
  size = 2,
  color = 'currentColor',
  ...props
}: Omit<SVGProps<SVGSVGElement>, 'color'> & Props) => {
  return (
    <svg
      style={{ width: unitMapping[size], height: unitMapping[size] }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.99997 0H6.99997V1.59305C5.94668 1.72816 5.02875 2.09108 4.34349 2.66024C3.54636 3.32233 3.07655 4.25435 3.07655 5.3882V5.40603C3.07655 6.42489 3.41864 7.23089 4.08167 7.84664C4.73524 8.45362 5.68216 8.85862 6.86405 9.12595L6.99997 9.1584V11.9003C6.69269 11.8179 6.4514 11.6941 6.26629 11.5397C5.99162 11.3105 5.82112 10.9975 5.7512 10.6L5.69694 10.3706H2.87723V10.5239L2.88058 10.6282C2.91854 11.8096 3.42495 12.7472 4.25699 13.4025C4.97359 13.967 5.92128 14.3147 6.99997 14.4446V16H8.99997V14.438C10.1152 14.3012 11.0891 13.9349 11.8128 13.3455C12.6372 12.674 13.1228 11.7233 13.1228 10.5403V10.5224C13.1228 9.48601 12.7807 8.68467 12.1011 8.07561C11.4332 7.47698 10.4589 7.08198 9.22711 6.80223L8.99997 6.75424V4.16295C9.23828 4.24927 9.43965 4.36849 9.60181 4.51656C9.86404 4.75599 10.038 5.08351 10.0936 5.5086L10.0989 5.54881V5.73667L12.9532 5.72682L12.9577 5.57286L12.9532 5.46709C12.9059 4.356 12.4521 3.41803 11.6785 2.73614C10.9984 2.13676 10.0821 1.74432 8.99997 1.59395V0ZM8.99997 11.9297V9.64666C9.38925 9.77355 9.65505 9.90616 9.83238 10.0529C10.0597 10.241 10.154 10.4625 10.154 10.7899V10.8077C10.154 11.1386 10.0312 11.3974 9.78308 11.5936C9.60151 11.7372 9.34392 11.8538 8.99997 11.9297ZM6.99997 4.1401V6.24447C6.72106 6.13535 6.51385 6.01726 6.36548 5.89034C6.14089 5.69822 6.04535 5.4818 6.04535 5.20993V5.1921C6.04535 4.90338 6.16015 4.65135 6.39486 4.45212C6.54307 4.32632 6.74354 4.21825 6.99997 4.1401Z"
        fill={color}
      />
    </svg>
  );
};
